import {
  DefaultActionsErrorView,
  ErrorBoundary,
  LoaderCentered,
} from '@modules/components';
import RemoteDocuments from '@modules/remotes/orders/documents';
import { Suspense } from 'react';

export function DocumentManagement() {
  return (
    <ErrorBoundary fallback={<DefaultActionsErrorView />}>
      <Suspense fallback={<LoaderCentered />}>
        <RemoteDocuments />
      </Suspense>
    </ErrorBoundary>
  );
}
